// extracted by mini-css-extract-plugin
module.exports = {"animatedBorderBottom":"about-us_animatedBorderBottom__HjhNb","pulse-blue":"about-us_pulse-blue__74lFV"};